module.exports = __webpack_public_path__ + "img/school.505db6d6.svg";